/**
 * オブジェクトをGETパラメータに変換します
 * 例）
 * {code:"test_code", name: "test_name"}
 *  のオブジェクトを変換すると
 * code=test_code&name=test_name
 *  となる
 * @param obj オブジェクト
 * @returns
 */
export const convertObjectToGetParameter = (obj: any) => {
	return Object.entries(obj)
		.filter((k) => !!k[1])
		.map((k) => `${k[0]}=${k[1]}`)
		.join('&');
};

export const convertObjectToGetParameterWithEncode = (obj: any, ...encodeKeys: string[]) => {
	return Object.entries(obj)
		.filter((k) => !!k[1])
		.map((k) => `${k[0]}=${encodeKeys.includes(k[0]) ? encodeURIComponent(String(k[1])) : k[1]}`)
		.join('&');
};
